// Full Menu List Componenet
export default class ComboCustomizeButton extends React.Component {
    constructor(props) {
        super(props);
        this.sendMoreOptionsDatanew = this.sendMoreOptionsDatanew.bind(this);

        //console.log("ComboCustomizeButton props ", this.props); 
    }

    componentDidMount() {
        this.props.sendOptionsData(this.props.getExtraToppingssData)
        this.props.sendModalHeaderText(this.props.modalTitle)
        this.props.sendModalHeaderId(this.props.modalId)
        this.props.sendModalImage(this.props.image)

        var reactRefThis = this;

        $(document).ready(function (e) {
            if (!reactRefThis.props.disableModalOnLoad) {

                var defaultItemTruthyStates = []
                defaultItemTruthyStates = reactRefThis.props.getExtraToppingssData[0].Modifiers.filter((modifier) => {
                    return (modifier.MenuItemDetail.IsDefault == true)
                })
                //console.log("check defaultItemTruthyStates.length " + defaultItemTruthyStates.length);
                //console.log("check defaultItemTruthyStates.data  " + defaultItemTruthyStates);
                if (defaultItemTruthyStates.length > 0) {
                    //console.log("defaultItemTruthyStates.length if " + defaultItemTruthyStates.length);
                    var preselecetdSub = [];
                    var preselecetdSubId = [];

                    preselecetdSub.push(defaultItemTruthyStates[0].MenuItemDetail.Name);
                    preselecetdSubId.push(defaultItemTruthyStates[0].MenuItemDetail.Id);

                    // this sends items to selectedCombo comp and then closes modal
                    reactRefThis.props.sendPreselected({
                        "parentTitle": reactRefThis.props.modalTitle,
                        "parentId": reactRefThis.props.modalId,
                        "newValue": (preselecetdSub.join(", ")).toString(),
                        "listOfIds": (preselecetdSubId.join(", ")).toString(),
                        "totalPrice": parseFloat(defaultItemTruthyStates[0].MenuItemDetail.CalcPrice)
                    })

                    //var SelectedItemsKey = `default-mod${reactRefThis.props.modalTitle}`
                    var SelectedItemsKey = `default-mod-${reactRefThis.props.modalId}`
                    //console.log("SelectedItemsKey " + SelectedItemsKey);
                    //console.log(" sessionStorage.setItem defaultItemTruthyStates[0].MenuItemDetail.Id " + defaultItemTruthyStates[0].MenuItemDetail.Id)
                    sessionStorage.setItem([SelectedItemsKey], JSON.stringify({
                        "selectedItem": defaultItemTruthyStates[0].MenuItemDetail.Name,
                        "selectedItemId": defaultItemTruthyStates[0].MenuItemDetail.Id
                    }))

                } else if (defaultItemTruthyStates.length == 0) {
                   // $('#information_modal').modal('show')
                }
                //hide sumenus containner when modal firsts opens
                $('#subMenusContainer').hide();
                // $('#subMenusContainer').show();
                $("#modalContent").show();

            }
        });

    }

    sendMoreOptionsDatanew() {
        //activate modal behavior when customize button is clisked
        $("#noModal").attr("id", "information_modal");
       // $("#modal_view_right").click();

        setTimeout(() => {
            // Validate the checkbox checked count and if already reached maximum level block further check
            var maxSelectCheckCountCal = $('#batch0').attr('data-maxselects');
            var checkedCountInputCal = $('#batch0 #comboRadioBtn > input[type=checkbox]:checked').length;
            //console.log('checkedCountInputCal ' + checkedCountInputCal);
            if (maxSelectCheckCountCal > 1) {
                //console.log('maxSelectCheckCountCal greater than 1');
                if (checkedCountInputCal >= maxSelectCheckCountCal) {
                    //console.log('checked count greater than or equal max count');
                    $('#batch0 #comboRadioBtn > input[type=checkbox]:not(:checked)').attr('disabled', true);
                }
                else {
                    //console.log('checkedCountInputCal checked count less than max count');
                    $('#batch0 #comboRadioBtn > input[type=checkbox]').attr('disabled', false);
                }
            }
        }, 500);

        //send data back to parent
        this.props.sendOptionsData(this.props.getExtraToppingssData);
        this.props.sendModalHeaderText(this.props.modalTitle);
        this.props.sendModalHeaderId(this.props.modalId);
        this.props.sendModalImage(this.props.image);
        this.props.sendCardOpensModalStatus(false);
        this.props.resetModalContent(false);
        this.props.IsCustomizedItem(true)

        //only the first view must be shown at every click of the customize button
        $('#subMenusContainer').hide()
        $("#modalContent").show();
        if (this.props.cardSubId != null) {
            //var subCheckboxKey = this.props.cardSubTitle.split(",");
            var subCheckboxKey = this.props.cardSubId;
            if (typeof subCheckboxKey == "string") {
                subCheckboxKey = this.props.cardSubId.replace(/\s*,\s*/g, ",").split(",");
            }
            //var subCheckboxKey = this.props.cardSubId.replace(/\s*,\s*/g, ",").split(",");
            //console.log("currentButtonSnapshotForSubs subCheckboxKey ", subCheckboxKey);
            setTimeout(() => {
                $('#subMenusContainer input').prop('checked', false);
                var currentButtonSnapshotForSubs = [];
                subCheckboxKey.map((value, index) => {
                    //console.log("Get the sessionstorage " + index + ': ' + value);
                    if (sessionStorage.getItem(`default-mod-${value}`)) {
                        currentButtonSnapshotForSubs[index] = JSON.parse(sessionStorage.getItem(`default-mod-${value}`));
                        //console.log("currentButtonSnapshotForSubs " + currentButtonSnapshotForSubs[index].selectedItemId);
                        var selectedItemForSubs = $('input[data-toppingid="' + currentButtonSnapshotForSubs[index].selectedItemId + '"]')
                        $(selectedItemForSubs).prop('checked', true);
                        var SelectedChevron = $('i[data-toppingid="' + value + '"]')
                        if (SelectedChevron.length > 0) {
                            console.log("SelectedChevron ******* ", SelectedChevron);
                            SelectedChevron.closest(".cart-items").addClass("selected");
                            SelectedChevron.parent('div#moreOptions').parent('div.col-2').siblings('.js-cart-item-product-img').find('i.selected-combo').removeClass('d-none');
                        }
                        if (sessionStorage.getItem('selected-submenuid')) {
                           // console.log("selected-submenuid *** ", sessionStorage.getItem('selected-submenuid'));
                            var selectedSubMenuToppings = sessionStorage.getItem('selected-submenuid');
                            $('i[data-toppingid="' + selectedSubMenuToppings + '"]').closest(".cart-items").addClass("selected");
                            $('i[data-toppingid="' + selectedSubMenuToppings + '"]').parent('div#moreOptions').parent('div.col-2').siblings('.js-cart-item-product-img').find('i.selected-combo').removeClass('d-none');
                        }
                    }
                });

            }, 200);

            //var currentButtonSnapshotForSubs = JSON.parse(sessionStorage.getItem(`default-mod-${subCheckboxKey[0]}`))

        }

        //var currentSessionKey = `default-mod-${this.props.modalTitle}`
        var currentSessionKey = `default-mod-${this.props.modalId}`
        //var productItemIdRenders = $('#modal_view_right').attr('data-selectedId');
        //var currentSessionKey = `default-mod-` + (productItemIdRenders)

        //console.log("currentSessionKey data " + currentSessionKey);
        setTimeout(() => {
            var currentButtonSnapshot = JSON.parse(sessionStorage.getItem(currentSessionKey))
            //console.log("currentButtonSnapshot actual data " + currentButtonSnapshot);
            var selectedItem = currentButtonSnapshot != null ? $('input[data-toppingid="' + currentButtonSnapshot.selectedItemId + '"]') : '';
            //console.log("selectedItem actual data " + selectedItem);

            $(selectedItem).prop('checked', true);
            $(selectedItem).closest(".cart-items").addClass("selected");
        }, 200);

        setTimeout(() => {
            //console.log(" ** Targe ** ");
           // $('#information_modal #comboSaveButton').attr("disabled", 'disabled');
        }, 500);

    }

    render() {
        return (
            <div>
                <button
                    data-selectedtitle={this.props.modalTitle}
                    data-selectedId={this.props.modalId}
                    className="btn btn-rewards float-right"
                    id="modal_view_rightnew"
                    data-toggle="modal"
                    data-target="#information_modal">
                    {this.props.CustomizeText}
                </button>

            </div>
        );
    }
}
